
export class OrderBy {
property: string;
way: any;
}

